<template>
  <h1>Zona de ayuda</h1>
</template>

<script>
export default {

}
</script>